import React from 'react';
import { styled } from '@mui/material/styles';
import NumberInput from '../NumberInput';

type TProps = {
  value: number | string | undefined;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

export const PriceInput: React.FC<TProps> = ({
  value,
  handleChange,
  handleBlur
}) => {
  return (
    <InputContainer>
      <StyledNumberInput
        symbol=''
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        dynamicCalculation={true}
        // === 0 ? "" : billingTotal
      />
    </InputContainer>
  );
};

const InputContainer = styled('div')({
  marginLeft: 10,
  marginRight: 10,
  paddingRight: 10,
  width: '100%'
});

const StyledNumberInput = styled(NumberInput)({
  height: 40,
  width: '100%',
  borderColor: '#c1c1c1',
  borderWidth: 1
});
